import CoreBase from '../../../../services/engines/CoreBase';
import shellInjector from './ShellInjector';
import sectionInjector from './SectionInjector';
import themeInjector from './ThemeInjector';
import widgetInjector from './WidgetInjector';
import dataInjector from './DataInjector';
import urlRewriter from './UrlRewriter';

class HtmlBuilder extends CoreBase {
    _name = 'HtmlBuilder';

    /**
     * Builds final HTML from templateJson and enriched data.
     * Volgorde is belangrijk — elke stap bouwt voort op de vorige:
     * 1. shell    — basis HTML structuur met placeholders
     * 2. sections — templateJson.sections injecteren als const sections
     *               zodat core widget weet welke sections te renderen
     * 3. themes   — CSS notes samenvoegen in <style> blok
     * 4. widgets  — JS notes samenvoegen als <script> blokken
     * 5. data     — data note content + layoutConfig injecteren in placeholders
     * 6. rewrite  — relatieve URLs herschrijven naar absolute
     * @param {object} templateJson
     * @param {object} enriched
     * @param {object} settings
     * @returns {string|null}
     */
    build(templateJson, enriched, settings) {
        // stap 1 — laad de HTML shell via htmlRk
        let html = shellInjector.load(templateJson);
        if (!html) return null;

        // stap 2 — sections injecteren vóór widgets zodat const sections beschikbaar
        //           is wanneer de core widget initialiseert op DOMContentLoaded
        html = sectionInjector.inject(html, templateJson);

        // stap 3 — CSS themes samenvoegen
        html = themeInjector.inject(html, templateJson);
        if (!html) return null;

        // stap 4 — JS widgets samenvoegen
        html = widgetInjector.inject(html, templateJson);
        if (!html) return null;

        // stap 5 — data note content + layoutConfig injecteren
        html = dataInjector.inject(html, templateJson, enriched, settings);

        // stap 6 — relatieve URLs herschrijven naar absolute (bijv. voor assets)
        html = urlRewriter.rewrite(html);

        return html;
    }
}

const htmlBuilder = new HtmlBuilder();
export default htmlBuilder;
